export const UPDATE_SEARCH_QUERY = "UPDATE_SEARCH_QUERY";
export const ADD_INGREDIENT = "ADD_INGREDIENT";
export const REMOVE_INGREDIENT = "REMOVE_INGREDIENT";
export const SET_INGREDIENT_ERROR = "SET_INGREDIENT_ERROR";
export const SET_INPUT_VALUE = "SET_INPUT_VALUE";
export const OPEN_POPUP = "OPEN_POPUP";
export const CLOSE_POPUP = "CLOSE_POPUP";
export const SET_SELECTED_RECIPE = "SET_SELECTED_RECIPE";
export const FETCH_RECIPES_START = "FETCH_RECIPES_START";
export const FETCH_RECIPES_SUCCESS = "FETCH_RECIPES_SUCCESS";
export const FETCH_RECIPES_FAILURE = "FETCH_RECIPES_FAILURE";
export const TOGGLE_SEARCH_BUTTON = "TOGGLE_SEARCH_BUTTON";
export const SET_NEXT_PAGE_URL = "SET_NEXT_PAGE_URL";
